import { useEffect } from "react";
import PageLoader from "./PageLoader";
import { beginPending, endPending } from "../Utils/networkTracker";

// Suspense fallback: tells ContentReveal that the page is still being downloaded
const PendingLoader = () => {
  useEffect(() => {
    beginPending();
    return endPending;
  }, []);
  return <PageLoader />;
};

export default PendingLoader;
